const formDatePickerDateFormat = 'MMMM d, yyyy';

export default formDatePickerDateFormat;
